<template>
  <div class="remunerationReport">
      <Header></Header>
      <div class="container">
          <div class="main_wrapper">
              <h2 data-aos="fade-up">{{this.bnrc.title}}</h2>
                <p data-aos="fade-up">{{this.bnrc.text}}</p>
            <h1 data-aos="fade-up">{{this.bnrc.title_two}}</h1>
            
            <p data-aos="fade-up">{{this.bnrc.contents.discription}}</p> 
            <p data-aos="fade-up">{{this.bnrc.contents.title}}</p>
            <ol>
                <li v-for ="text in this.bnrc.contents.listing" :key="text"  data-aos="fade-up">{{text}}</li>
            </ol>  
            <p v-for ="text in this.bnrc.paragraph" :key="text"  data-aos="fade-up">{{text}}</p>
            <h2  data-aos="fade-up">{{this.br.title}}</h2>
            <ul >
                <li v-for="text in this.br.listing" :key="text" data-aos="fade-up">{{text}}</li>
            </ul>
            <h2  data-aos="fade-up">{{this.emr.main_title}}</h2>
            <p data-aos="fade-up">{{this.emr.title}}</p>
            <p class="bold" data-aos="fade-up"><strong>{{this.emr.small_text}}</strong></p>
            <ul >
                <li v-for="text in this.emr.listing" :key="text" data-aos="fade-up">{{text}}</li>
            </ul>
            <p class="bold" data-aos="fade-up"><strong>{{this.emr.small_text_two}}</strong></p>
            <p  data-aos="fade-up">{{this.emr.small_para}}</p>
            <ul>
                <li v-for="text in this.emr.listing2" :key="text" data-aos="fade-up">{{text}}</li>
            </ul>
            <h2 data-aos="fade-up">{{this.balance.title}}</h2>
            <p>{{this.balance.desc}}</p>

            <div class="table-wrapper on-575" v-if="$i18n.locale=='en'">
                <div class="custom-table governance"  data-aos="fade-up">
                    <div class="table-heading">Remunerations of Executive Management at Zain Group 2020 :</div>
                    <div class="trow head border-0 bg-green">
                        <div class="th"><strong>No. OF EMPLOYEES</strong></div>
                        <div class="th"><strong>FIXED  <br>REMUNERATION<br> (KWD 000’)</strong></div>
                        <div class="th"><strong>VARIABLE<br>REMUNERATION<br> (KWD 000’)</strong></div>
                        <div class="th border-right-0"><strong>TOTAL<br> (KWD 000’)</strong></div>
                    </div>
                    <div class="trow">
                        <div class="gray brdr-right">9</div>
                        <div class="gray brdr-right">3,146</div>
                        <div class="gray brdr-right">1,832</div>
                        <div class="gray brdr-right border-right-0">4,979</div>
                    </div>
            </div>
            
            </div>
            <div class="table-wrapper on-575" v-if="$i18n.locale=='ar'">
                <div class="custom-table governance"  data-aos="fade-up">
                    <div class="table-heading">مكافآت الإدارة التنفيذية في مجموعة زين</div>
                    <div class="trow head border-0 bg-green">
                        <div class="th"><strong>عدد الموظفين</strong></div>
                        <div class="th"><strong>مكافآت ثابتة<br> (د.ك. بالآلاف)</strong></div>
                        <div class="th"><strong>مكافآت متغيرة<br> (د.ك. بالآلاف)</strong></div>
                        <div class="th border-right-0"><strong>المجموع<br> (د.ك. بالآلاف)</strong></div>
                    </div>
                    <div class="trow">
                        <div class="gray brdr-right">9</div>
                        <div class="gray brdr-right">3,146</div>
                        <div class="gray brdr-right">1,832</div>
                        <div class="gray brdr-right border-right-0">4,979</div>
                    </div>
            </div>
            
            </div>
          </div>
      </div>
  </div>
</template>

<script>

import data from "@/components/governance/json/BRNC.json";
const bnrc =[];
const br =[];
const emr =[];
export default {
    components:{
        // sctionsScroll
    },
    data(){
        return{
            bnrc: data.bnrc,
            br:data.br,
            emr:data.emr,
            balance:data.balance
        }
    },
    created(){
        if(this.$i18n.locale=="en"){
            this.bnrc =  data.en.bnrc,
            this.br = data.en.br,
            this.emr = data.en.emr,
            this.balance = data.en.balance
            
            
        }
        else{
            this.bnrc =  data.ar.bnrc,
            this.br = data.ar.br,
            this.emr = data.ar.emr,
            this.balance = data.ar.balance
            
        }
    },
    methods : {
       
    },
    mounted(){
       
    }

}
</script>
<style lang="scss">
    [data-page="Remuneration-Report"]{
        .verticalLabel{
            color:#949699;
        }
    }
</style>
<style lang="scss" scoped>

.remunerationReport{
    background: #E8E8E8;
    overflow:hidden;
    padding-bottom:rem(30px);
    .main_wrapper{
        margin-top: rem(100px);
           .custom-table {
            margin:rem(30px) 0;
            display: table;
            table-layout: fixed;
            width: 100%;
            .table-heading {
                background: #dedfe0;
                color: #00a982;
                font-size: 25px;
                font-weight: 600;
                padding: 10px;
                border-top: 1px solid #000;
                border-bottom: 1px solid #000;
                @media screen and (max-width:767px){
                    font-size:rem(20px);
                }
            }
            .trow {
            display: table;
            table-layout: fixed;
            border-bottom: 1px solid #000;
            width: 100%;
            background: #fff;
            }
            .trow.head {
            background: #dedfe0;
            color: #000;
            border: 0;
            }
            .th {
                color: #000;
                font-weight: 600;
                text-transform: uppercase;
                &:not(:last-child){
                    border-right: 1px solid black;
                }
            }
            .th {
            font-size: 16px;
            font-weight: 700;
            padding: 10px;
            border: 0;
            vertical-align: middle;
            @media screen and (max-width:767px){
                font-size:14px;
            }
            }
            .brdr-right{
                border-right: 1px solid black;
                border-top: 1px solid black !important;
            }
            .trow {
            display: table;
            table-layout: fixed;
            border-bottom: 1px solid #000;
            width: 100%;
            background: #fff;
            
        }
    }
    }
    .border-right-0{
        border-right:0 !important;
    }
    h1 {
        font-size: rem(35px);
        font-weight: 900;
        margin-bottom:rem(40px);
        color:#656769;
        @media screen and (max-width:767px){
            font-size: rem(25px);
            margin-bottom:rem(20px);
        }
          
    }
    h2{
        font-size: rem(20px);
        font-weight: 900;
        margin-bottom: rem(15px);
        margin:rem(35px) 0 rem(15px) 0;
        color:#656769;
        @media screen and (max-width:767px){
            font-size: rem(18px);
            margin:rem(25px) 0 rem(15px) 0;
        }
          
    }
    p{
        font-size: rem(18px);
        font-weight: 600;
        color: #707070;
        line-height: 1.3;
    }
    .bold{
        font-size: rem(20px);
        font-weight: 800;
        color: #707070;
    }

    ul{
        margin-left: rem(25px);
        margin-bottom:rem(40px);
        @media screen and (max-width:767px){
            margin-bottom:rem(20px);
        }
        li{
            font-size: rem(18px);
            font-weight: 600;
            color: #707070;
            line-height: 1.3;
            &:not(:last-child){
               margin-bottom: rem(15px); 
            }
        }
    }
    ol{
        margin-left: rem(55px);
        margin-bottom:rem(40px);
        @media screen and (max-width:991px){
            margin-left:rem(25px);
        }
        @media screen and (max-width:767px){
            margin-bottom:rem(20px);
        }
        li{
            font-size: rem(18px);
            font-weight: 600;
            color: #707070;
            line-height: 1.4;
            &:not(:last-child){
               margin-bottom: rem(15px); 
            }
        }
    }
    .seaGreen{
        color: #00a982;
        font-weight:700;
    }
    .gray{
        color: #707070;
    }
    .bold{
        font-size: rem(18px);
        font-weight: 700;
        line-height: 1.3;
    }
    
}


[lang="ar"]{
    .remunerationReport{
        .main_wrapper{
            .custom-table {
                .th {
                    &:not(:last-child){
                        border-left: 1px solid black;
                        border-right:0;
                    }
                }
                .brdr-right{
                    border-left: 1px solid black;
                    border-right:0;
                }
            }
        }
        .border-right-0{
            border-left:0 !important;
        }

        ul{
            margin-right: rem(25px);
            margin-left:0;
        }
        ol{
            margin-right: rem(55px);
            margin-left:0;
            @media screen and (max-width:991px){
                margin-right:rem(25px);
                margin-left:0;
            }
        }   
    }
}

</style>